import React, { type ReactNode } from 'react'
import { LayoutBand } from '@fs/zion-ui'
import { PersonBandSkeleton } from '@fs/zion-person-band'
import useSubPersonPageGutters from './useSubPersonPageGutters'

type Props = {
  children: ReactNode
  maxWidth?: 'xl' | 'lg'
}

export default function SubPersonPageDecoratorSkeleton({ children, maxWidth = 'lg' }: Props): JSX.Element {
  const { marginX, marginY } = useSubPersonPageGutters()

  return (
    <>
      <PersonBandSkeleton disableColoredBackground hasBackButton marginX={marginX} maxWidth={maxWidth} />

      <LayoutBand maxWidth={maxWidth} marginX={marginX} marginY={marginY} minHeight="100vh">
        {children}
      </LayoutBand>
    </>
  )
}
